import { useState, useCallback, useRef } from 'react';
import { Trash2, Lock } from 'lucide-react';

function ConfirmModalUI({ title, subtitle, body, confirmLabel = 'Confirmer', confirmColor = '#dc2626', icon: Icon = Trash2, onConfirm, onCancel }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,15,40,0.65)', zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
      onClick={onCancel}>
      <div style={{ background: 'white', borderRadius: 20, width: '100%', maxWidth: 460, boxShadow: '0 32px 80px rgba(0,0,0,0.35)', overflow: 'hidden' }}
        onClick={e => e.stopPropagation()}>

        {/* En-tête coloré */}
        <div style={{ background: `linear-gradient(135deg, ${confirmColor} 0%, ${confirmColor}cc 100%)`, padding: '32px 28px 36px', textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: 20, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
            <Icon size={30} color="white" />
          </div>
          <div style={{ fontSize: 18, fontWeight: 700, color: 'white', letterSpacing: -0.3 }}>{title}</div>
        </div>

        {/* Corps */}
        <div style={{ padding: '24px 28px 28px' }}>
          {subtitle && (
            <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 12, padding: '12px 16px', marginBottom: 16, fontWeight: 600, fontSize: 13, color: '#374151', textAlign: 'center' }}>
              {subtitle}
            </div>
          )}
          {body && (
            <div style={{ fontSize: 13, color: '#4b5563', lineHeight: 1.7, whiteSpace: 'pre-line', marginBottom: 24, textAlign: 'center' }}>{body}</div>
          )}
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={onCancel}
              style={{ flex: 1, padding: '12px', borderRadius: 10, border: '1.5px solid #e5e7eb', background: 'white', color: '#374151', fontWeight: 600, cursor: 'pointer', fontSize: 13 }}>
              Annuler
            </button>
            <button onClick={onConfirm}
              style={{ flex: 2, padding: '12px', borderRadius: 10, border: 'none', background: confirmColor, color: 'white', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>
              {confirmLabel}
            </button>
          </div>
          <div style={{ textAlign: 'center', marginTop: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
            <Lock size={10} color="#d1d5db" />
            <span style={{ fontSize: 10, color: '#d1d5db', fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase' }}>QBDP · Quality Badge & Digital Protocol</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function useConfirm() {
  const [state, setState] = useState({ visible: false, opts: {} });
  const resolveRef = useRef(null);

  const showConfirm = useCallback((opts) => {
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setState({ visible: true, opts });
    });
  }, []);

  const handleConfirm = () => {
    setState({ visible: false, opts: {} });
    resolveRef.current?.(true);
    resolveRef.current = null;
  };

  const handleCancel = () => {
    setState({ visible: false, opts: {} });
    resolveRef.current?.(false);
    resolveRef.current = null;
  };

  const confirmModal = state.visible ? (
    <ConfirmModalUI {...state.opts} onConfirm={handleConfirm} onCancel={handleCancel} />
  ) : null;

  return { showConfirm, confirmModal };
}
